import { FC } from 'react';
import { FormItem, FormStateCheckboxItem, OnBlurFormInput, OnChangeFormInput } from '../../../hooks/common/useForm';
import style from './index.module.css';

export const CancelSurvey: FC<{
  state: FormItem,
  onChange: OnChangeFormInput,
  onBlur: OnBlurFormInput
}> = ({ state, onChange, onBlur }) => {

  const items = state.items as FormStateCheckboxItem[];

  return (
    <fieldset className={style.wrapper}>
      {items.length > 0 && items.map((reason, index) => {
        const r = reason as FormStateCheckboxItem 
        return (
          <label key={index} className={style.label}>
            <input 
              className={style.input}
              type="checkbox"
              name={state.name}
              value={r.value}
              checked={r.checked}
              onChange={onChange}
              onBlur={onBlur}
            />
            <span className={style.span}>{r.value}</span>
          </label>
        )
      })}
      {state.status === 'error' && <div className={style.error}>※{state.error}</div>}
    </fieldset>
  );
}